import { queryOptions, useQuery } from '@tanstack/react-query';

import { storesApi } from '../api/stores-api';

import { storeKeys } from './store-keys';

export function storeReadinessQueryOptions(id: string) {
  return queryOptions({
    queryKey: storeKeys.readiness(id),
    queryFn: () => storesApi.readiness(id),
  });
}

/** `enabled: false` for roles that cannot read the store; the query stays idle. */
export function useStoreReadiness(id: string, enabled = true) {
  return useQuery({ ...storeReadinessQueryOptions(id), enabled });
}
